<template>
  <NuxtImg
    :src="image?.filename ?? ''"
    :alt="image?.alt ?? ''"
    format="webp"
    :loading="fetchPriority == 'high' ? 'eager' : 'lazy'"
    :fetchPriority="fetchPriority"
    v-bind="{
      width,
      height,
      placeholder,
    }"
  />
</template>

<script lang="ts" setup>
import { AssetStoryblok } from "~/types/bloks";

withDefaults(
  defineProps<{
    image?:
      | {
          filename: string;
          alt: string;
        }
      | AssetStoryblok;
    optimize?: boolean;
    width?: string;
    height?: string;
    placeholder?: boolean;
    fetchPriority?: "high" | "low" | "auto";
  }>(),
  {
    fetchPriority: "auto",
  }
);
</script>
